import styles from './Block.module.css'

export const Block = (props) => (
    <div tabIndex={props.disabled ? 0 : 1} className={` ${props.className} ${styles.block} ${props.disabled ? styles.disabled : ""} border px-1 py-1 mt-1`} {...props}>
        {props.children}
    </div>
);